(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('musical-piece-ibq', {
            parent: 'entity',
            url: '/musical-piece-ibq?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.musicalPiece.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/musical-piece/musical-piecesibq.html',
                    controller: 'MusicalPieceIbqController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('musicalPiece');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('musical-piece-ibq-detail', {
            parent: 'musical-piece-ibq',
            url: '/musical-piece-ibq/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'virtuallibraryApp.musicalPiece.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/musical-piece/musical-piece-ibq-detail.html',
                    controller: 'MusicalPieceIbqDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('musicalPiece');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MusicalPiece', function($stateParams, MusicalPiece) {
                    return MusicalPiece.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'musical-piece-ibq',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('musical-piece-ibq-detail.edit', {
            parent: 'musical-piece-ibq-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/musical-piece/musical-piece-ibq-dialog.html',
                    controller: 'MusicalPieceIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MusicalPiece', function(MusicalPiece) {
                            return MusicalPiece.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('musical-piece-ibq.new', {
            parent: 'musical-piece-ibq',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/musical-piece/musical-piece-ibq-dialog.html',
                    controller: 'MusicalPieceIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                mainTitle: null,
                                alternateTitle: null,
                                subtitle: null,
                                dedication: null,
                                compositionYear: null,
                                cover: null,
                                coverContentType: null,
                                musicalPiecePath: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('musical-piece-ibq', null, { reload: 'musical-piece-ibq' });
                }, function() {
                    $state.go('musical-piece-ibq');
                });
            }]
        })
        .state('musical-piece-ibq.edit', {
            parent: 'musical-piece-ibq',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/musical-piece/musical-piece-ibq-dialog.html',
                    controller: 'MusicalPieceIbqDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MusicalPiece', function(MusicalPiece) {
                            return MusicalPiece.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('musical-piece-ibq', null, { reload: 'musical-piece-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('musical-piece-ibq.delete', {
            parent: 'musical-piece-ibq',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/musical-piece/musical-piece-ibq-delete-dialog.html',
                    controller: 'MusicalPieceIbqDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MusicalPiece', function(MusicalPiece) {
                            return MusicalPiece.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('musical-piece-ibq', null, { reload: 'musical-piece-ibq' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
